﻿// Feature 034: PrÃ©via de AnÃ¡lise de Resultado â€” cliente dos endpoints admin.
import apiClient from './api.service';
import type { SurveyAnalysisPayload } from './surveyAnalysis.service';
import type {
  PreviewAnalysisAccepted,
  PreviewAnalysisDetail,
  PreviewAnalysisPayloadResponse,
  PreviewAnalysisSummary,
} from '../types/preview-analysis.types';

export const surveyPreviewAnalysisService = {
  /** POST /api/surveys/:surveyId/analysis/preview — aceita 201 legado ou 202 assíncrono. */
  async triggerPreviewAnalysis(surveyId: string): Promise<PreviewAnalysisAccepted> {
    const response = await apiClient.post(
      `/api/surveys/${surveyId}/analysis/preview`,
      {}
    );
    return {
      data: response.data,
      status: response.status as 201 | 202,
      location: response.headers.location ?? null,
      accepted: response.status === 202,
    };
  },

  /** GET /api/surveys/:surveyId/analysis/preview â€” linha do tempo (sem payload). */
  async listPreviewAnalyses(
    surveyId: string
  ): Promise<PreviewAnalysisSummary[]> {
    const response = await apiClient.get(
      `/api/surveys/${surveyId}/analysis/preview`
    );
    return response.data?.items ?? [];
  },

  /** GET /api/surveys/:surveyId/analysis/preview/:previewId â€” metadados (sem payload). */
  async getPreviewAnalysis(
    surveyId: string,
    previewId: string
  ): Promise<PreviewAnalysisDetail> {
    const response = await apiClient.get(
      `/api/surveys/${surveyId}/analysis/preview/${previewId}`
    );
    return response.data;
  },

  /**
   * Busca o payload estatÃ­stico da anÃ¡lise prÃ©via. O arquivo pode passar de 6MB
   * (teto da resposta do Lambda), entÃ£o o back-end devolve uma URL prÃ©-assinada
   * e nÃ³s baixamos o JSON direto do bucket. Em dev (sem S3) o payload jÃ¡ vem
   * inline na prÃ³pria resposta.
   */
  async getPreviewAnalysisPayload(
    surveyId: string,
    previewId: string
  ): Promise<SurveyAnalysisPayload | null> {
    const { data } = await apiClient.get<PreviewAnalysisPayloadResponse>(
      `/api/surveys/${surveyId}/analysis/preview/${previewId}/payload-url`
    );
    if (data.payload) return data.payload;
    if (!data.url) return null;
    // fetch "cru": a URL prÃ©-assinada nÃ£o aceita cabeÃ§alhos de auth nossos.
    const res = await fetch(data.url);
    if (!res.ok) {
      throw new Error('Falha ao baixar o resultado da anÃ¡lise prÃ©via do storage.');
    }
    return (await res.json()) as SurveyAnalysisPayload;
  },

  /** POST /api/surveys/:surveyId/analysis/preview/:previewId/retry â€” sÃ³ de FAILED. */
  async retryPreviewAnalysis(
    surveyId: string,
    previewId: string
  ): Promise<PreviewAnalysisAccepted> {
    const response = await apiClient.post(
      `/api/surveys/${surveyId}/analysis/preview/${previewId}/retry`,
      {}
    );
    return {
      data: response.data,
      status: response.status as 201 | 202,
      location: response.headers.location ?? null,
      accepted: response.status === 202,
    };
  },
};

export default surveyPreviewAnalysisService;


